import * as React from 'react'

export const ArrowDown = (props: any) => (
    <svg
        width={10}
        height={6}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M5.384 5.54a.5.5 0 0 1-.768 0L.683.82A.5.5 0 0 1 1.068 0h7.864a.5.5 0 0 1 .385.82L5.384 5.54Z'
            fill='#818181'
        />
    </svg>
)
